import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProfileState {
    firstName: string;
    lastName: string;
    mobile: string;
    email: string;
    residence: string;
    zipcode: string;
    degreePursue: string;
    profilePic: string;
    gpaValue: { unweighted: string, weighted: string, underGraduate: string, graduate: string },
    experience: { years: string, months: string, researchYears: string, researchMonths: string },
    selectedTests: { test: string; score: string | null }[];
    selectedLangTests: { test: string; score: string | null }[];

    inputError: { test: string, error: boolean },
    discipline: string | null;
    yearOfPursue: string |null;
    priorities: any[],
    tuitionFee: string,
    disableBtn: boolean,
    isResumeUpload: boolean,
    disableSaveBtn: boolean,
    [key: string]: any;
}

const initialState: ProfileState = {
    firstName: '',
    lastName: '',
    mobile: '',
    email: '',
    residence: '',
    zipcode: '',
    profilePic: '',
    degreePursue: '',
    gpaValue: {
        unweighted: '',
        weighted: '',
        underGraduate: '',
        graduate: ''
    },
    experience: {
        years: '', months: '', researchYears: '', researchMonths: ''
    },
    selectedTests: [{ test: "SAT", score: null }],
    selectedLangTests: [{ test: "TOEFL", score: null }],

    inputError: { test: '', error: false },
    discipline: null,
    yearOfPursue: '',
    priorities: [],
    tuitionFee: '',
    disableBtn: true,
    isResumeUpload: false,
    disableSaveBtn: false,
};

const profileSlice = createSlice({
    name: 'profileData',
    initialState,
    reducers: {
        updateProfileField: (state, action: PayloadAction<{ field: string; value: any }>) => {
            state[action.payload.field] = action.payload.value;
        },
        updateProfileSaveDisable: (state, action) => {
            state.disableSaveBtn = action.payload;
        },
        updateProfileGpa: (state, action: PayloadAction<Partial<ProfileState["gpaValue"]>>) => {
            state.gpaValue = { ...state.gpaValue, ...action.payload }
        },
        updateProfileExperience: (state, action: PayloadAction<Partial<ProfileState["experience"]>>) => {
            state.experience = { ...state.experience, ...action.payload }
        },
        updateProfileLangTests: (state, action: PayloadAction<ProfileState["selectedLangTests"]>) => {
            state.selectedLangTests = action.payload;
        },
        updateProfileTests: (state, action: PayloadAction<ProfileState["selectedTests"]>) => {
            state.selectedTests = action.payload;
        },
        updateProfileInputError: (state, action: PayloadAction<ProfileState["inputError"]>) => {
            state.inputError = action.payload;
        },
        clearProfileData: () => initialState,
    },
});

export const {
    updateProfileField,
    updateProfileGpa,
    updateProfileExperience,
    updateProfileLangTests,
    updateProfileTests,
    updateProfileInputError,
    updateProfileSaveDisable,
    clearProfileData
} = profileSlice.actions;

export default profileSlice.reducer;
